module.exports = __webpack_public_path__ + "img/09d.560c1fc2.svg";